import aigLogo from "./logos/aig.webp";
import aroLogo from "./logos/aro.webp";
import axaLogo from "./logos/axa.webp";
import chiswellLogo from "./logos/chiswell.webp";
import churchillLogo from "./logos/churchill.webp";
import coveaLogo from "./logos/covea.webp";
import finsburyLogo from "./logos/finsbury.webp";
import hiscoxLogo from "./logos/hiscox.webp";
import lexiconLogo from "./logos/lexicon.webp";
import maltingsLogo from "./logos/maltings.webp";
import meliusLogo from "./logos/melius.webp";
import modusLogo from "./logos/modus.webp";
import qbeLogo from "./logos/qbe.webp";
import rsaLogo from "./logos/rsa.webp";
import unoLogo from "./logos/uno.webp";
import zurichLogo from "./logos/zurich.webp";

export type InsurerLogoData = {
  src: string;
  alt: string;
};

export const INSURER_DATA: Record<string, InsurerLogoData> = {
  aig: {
    src: aigLogo,
    alt: "AIG Insurance",
  },
  aro: {
    src: aroLogo,
    alt: "ARO Insurance",
  },
  axa: {
    src: axaLogo,
    alt: "AXA Insurance",
  },
  chiswell: {
    src: chiswellLogo,
    alt: "Chiswell Insurance",
  },
  churchill: {
    src: churchillLogo,
    alt: "Churchill Insurance",
  },
  covea: {
    src: coveaLogo,
    alt: "Covea Insurance",
  },
  finsbury: {
    src: finsburyLogo,
    alt: "Finsbury Insurance",
  },
  hiscox: {
    src: hiscoxLogo,
    alt: "Hiscox Insurance",
  },
  lexicon: {
    src: lexiconLogo,
    alt: "Lexicon Insurance",
  },
  maltings: {
    src: maltingsLogo,
    alt: "Maltings Insurance",
  },
  melius: {
    src: meliusLogo,
    alt: "Melius Insurance",
  },
  modus: {
    src: modusLogo,
    alt: "Modus Insurance",
  },
  qbe: {
    src: qbeLogo,
    alt: "QBE Insurance",
  },
  rsa: {
    src: rsaLogo,
    alt: "RSA Insurance",
  },
  uno: {
    src: unoLogo,
    alt: "Uno Insurance",
  },
  zurich: {
    src: zurichLogo,
    alt: "Zurich Insurance",
  },
};

export const BUSINESS_SHOP_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "lexicon",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const PROFESSIONAL_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "rsa",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const LANDLORD_INSURERS = [
  "axa",
  "churchill",
  "zurich",
  "covea",
  "aro",
  "modus",
  "melius",
  "uno",
  "chiswell",
  "finsbury",
  "maltings",
];

export const COMMERCIAL_LANDLORD_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "rsa",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury",
];

export const CONTRACTORS_COMBINED_INSURERS = ["qbe", "chiswell", "maltings"];
